import { render, staticRenderFns } from "./ResultTopicCarousel.vue?vue&type=template&id=f6d952d2&scoped=true"
import script from "./ResultTopicCarousel.vue?vue&type=script&lang=js"
export * from "./ResultTopicCarousel.vue?vue&type=script&lang=js"
import style0 from "./ResultTopicCarousel.vue?vue&type=style&index=0&id=f6d952d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d952d2",
  null
  
)

export default component.exports